// Accordion
class MFAccordion {
  constructor(accordion) {
    this.accordion = accordion;
    this.allowMultiple = accordion.dataset.allowMultiple === 'true';
    this.items = Array.from(
      accordion.querySelectorAll('.mf-accordion__item')
    );
    accordion._mfAccordion = this;

    this.init();
  }

  init() {
    this.items.forEach((item) => {
      const summary = item.querySelector('.mf-accordion__summary');
      const content = item.querySelector('.mf-accordion__content');

      if (!summary || !content) return;

      content.style.overflow = 'hidden';

      if (item.open) {
        item.classList.add('is-open');
        content.style.height = 'auto';
        content.style.opacity = '1';
      } else {
        item.classList.remove('is-open');
        content.style.height = '0px';
        content.style.opacity = '0';
      }

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (item.dataset.animating === 'true') return;

        if (item.open) {
          this.closeItem(item);
        } else {
          this.openItem(item);
        }
      });
    });
  }

  openItem(item) {
    const content = item.querySelector('.mf-accordion__content');
    if (!content) return;

    if (!this.allowMultiple) {
      this.items.forEach((otherItem) => {
        if (otherItem !== item && otherItem.open) {
          this.closeItem(otherItem);
        }
      });

      // M5: PDP product accordions are separate [data-accordion] wrappers;
      // close open items in other .mf-product-accordion groups on the page.
      if (this.accordion.classList.contains('mf-product-accordion')) {
        document
          .querySelectorAll('.mf-product-accordion[data-accordion]')
          .forEach((otherAccordion) => {
            if (otherAccordion === this.accordion) return;
            const otherInstance = otherAccordion._mfAccordion;
            if (!otherInstance) return;
            otherInstance.items.forEach((otherItem) => {
              if (otherItem.open) {
                otherInstance.closeItem(otherItem);
              }
            });
          });
      }
    }

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    item.open = true;
    item.classList.add('is-open');

    if (reduceMotion) {
      content.style.height = 'auto';
      content.style.opacity = '1';
      return;
    }

    item.dataset.animating = 'true';

    content.style.height = '0px';
    content.style.opacity = '0';

    window.requestAnimationFrame(() => {
      const targetHeight = content.scrollHeight;

      content.style.height = `${targetHeight}px`;
      content.style.opacity = '1';
    });

    this.afterTransition(content, () => {
      content.style.height = 'auto';
      item.dataset.animating = 'false';
    });
  }

  closeItem(item) {
    const content = item.querySelector('.mf-accordion__content');
    if (!content) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      item.open = false;
      item.classList.remove('is-open');
      content.style.height = '0px';
      content.style.opacity = '0';
      return;
    }

    item.dataset.animating = 'true';

    content.style.height = `${content.scrollHeight}px`;
    content.style.opacity = '1';

    content.offsetHeight;

    item.classList.remove('is-open');

    window.requestAnimationFrame(() => {
      content.style.height = '0px';
      content.style.opacity = '0';
    });

    this.afterTransition(content, () => {
      item.open = false;
      item.dataset.animating = 'false';
    });
  }

  afterTransition(element, callback) {
    let called = false;

    const finish = () => {
      if (called) return;
      called = true;
      element.removeEventListener('transitionend', onTransitionEnd);
      callback();
    };

    const onTransitionEnd = (event) => {
      if (event.propertyName !== 'height') return;
      finish();
    };

    element.addEventListener('transitionend', onTransitionEnd);

    window.setTimeout(finish, 500);
  }
}

function initMFAccordions(context = document) {
  const accordions = context.querySelectorAll('[data-accordion]');

  accordions.forEach((accordion) => {
    if (accordion.dataset.initialized === 'true') return;

    accordion.dataset.initialized = 'true';
    new MFAccordion(accordion);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initMFAccordions();
});

document.addEventListener('shopify:section:load', (event) => {
  initMFAccordions(event.target);
});

// Parallax
class MFParallax {
  constructor(element) {
    this.element = element;
    this.speed = parseFloat(
      element.dataset.parallaxSpeed || '0.18'
    );

    this.ticking = false;
    this.mobileQuery = window.matchMedia(
      '(max-width: 749px)'
    );

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    this.bindEvents();
    this.render();
  }

  bindEvents() {
    window.addEventListener('scroll', this.onScroll, {
      passive: true
    });

    window.addEventListener('resize', this.onResize);
  }

  reset() {
    this.element.style.setProperty(
      'transform',
      'none',
      'important'
    );

    this.element.style.setProperty(
      'will-change',
      'auto',
      'important'
    );
  }

  onScroll() {
    /* Jangan jalankan perhitungan parallax sama sekali di mobile */
    if (this.mobileQuery.matches) {
      this.reset();
      return;
    }

    if (this.ticking) return;

    this.ticking = true;

    window.requestAnimationFrame(() => {
      this.render();
      this.ticking = false;
    });
  }

  onResize() {
    this.render();
  }

  render() {
    const reduceMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (this.mobileQuery.matches || reduceMotion) {
      this.reset();
      return;
    }

    const rect = this.element.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    /*
     * Parallax tetap dihitung sedikit sebelum elemen masuk
     * dan sesudah elemen keluar viewport.
     * Ini mencegah transform muncul/hilang mendadak.
     */
    const viewportBuffer = viewportHeight * 0.5;

    if (
      rect.bottom < -viewportBuffer ||
      rect.top > viewportHeight + viewportBuffer
    ) {
      return;
    }

    /*
     * Hapus !important dari reset mobile hanya ketika
     * elemen sudah mendekati viewport.
     */
    this.element.style.removeProperty('transform');
    this.element.style.removeProperty('will-change');

    const elementCenter = rect.top + rect.height / 2;
    const viewportCenter = viewportHeight / 2;
    const distance = elementCenter - viewportCenter;
    const translateY = distance * -this.speed;

    this.element.style.willChange = 'transform';
    this.element.style.transform =
      `translate3d(0, ${translateY}px, 0)`;
  }
}

function initMFParallax(context = document) {
  const parallaxItems = context.querySelectorAll('[data-parallax]');

  parallaxItems.forEach((item) => {
    if (item.dataset.parallaxInitialized === 'true') return;

    item.dataset.parallaxInitialized = 'true';
    new MFParallax(item);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initMFParallax();
});

document.addEventListener('shopify:section:load', (event) => {
  initMFParallax(event.target);
});

/* =========================================================
   MF Quick Add Active Variant Summary
========================================================= */

document.addEventListener('change', (event) => {
  const input = event.target;

  if (
    !(input instanceof HTMLInputElement) ||
    input.type !== 'radio'
  ) {
    return;
  }

  const modal = input.closest('.quick-add-modal');

  if (!modal) return;

  const summary = modal.querySelector(
    '.mf-quick-add-active-options'
  );

  if (!summary) return;

  const checkedOptions = Array.from(
    modal.querySelectorAll(
      '.product-form__input input[type="radio"]:checked'
    )
  );

  const values = checkedOptions
    .map((option) => option.value.trim())
    .filter(Boolean);

  if (!values.length) return;

  /*
   * Shopify product:
   * Option 1 = Color
   * Option 2 = Size
   *
   * Tampilan yang diinginkan:
   * SIZE — COLOR
   */
  const color = values[0] || '';
  const size = values[1] || '';

  summary.innerHTML = `
    ${size ? `<span>${size}</span>` : ''}
    ${
      size && color
        ? '<span aria-hidden="true">—</span>'
        : ''
    }
    ${color ? `<span>${color}</span>` : ''}
  `;
});

/* =========================================================
   MF PDP — quantity minus aria-disabled sync (product page only)
   Mirrors Dawn .disabled class; does not reimplement min/max.
========================================================= */

function syncMfProductQuantityMinusAria(root = document) {
  root.querySelectorAll('.mf-product-actions quantity-input').forEach((qi) => {
    const minus = qi.querySelector(".quantity__button[name='minus']");
    if (!minus) return;

    const sync = () => {
      minus.setAttribute(
        'aria-disabled',
        minus.classList.contains('disabled') ? 'true' : 'false'
      );
    };

    if (qi.dataset.mfMinusAriaSynced === 'true') {
      sync();
      return;
    }

    qi.dataset.mfMinusAriaSynced = 'true';
    sync();

    const input = qi.querySelector('.quantity__input');
    qi.addEventListener('click', () => {
      window.requestAnimationFrame(sync);
    });
    if (input) {
      input.addEventListener('change', () => {
        window.requestAnimationFrame(sync);
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', () => {
  syncMfProductQuantityMinusAria();
});

document.addEventListener('shopify:section:load', (event) => {
  syncMfProductQuantityMinusAria(event.target);
});

/* =========================================================
   MF PDP — VIEW SIZE GUIDE focus destination
========================================================= */

document.addEventListener('click', (event) => {
  const link = event.target.closest('a.mf-product-option__size-guide');
  if (!link) return;

  const guide = document.getElementById('size-guide');
  if (!guide) return;

  // Let default hash navigation / smooth scroll run, then move keyboard focus
  // without an extra scroll jump.
  window.requestAnimationFrame(() => {
    guide.focus({ preventScroll: true });
  });
});
